// Aviso de versión nueva (documento 07, service worker): nunca se actualiza sola en medio de una entrega.
import { Boton, Icono } from '@reparto/ui';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function AvisoVersion() {
  const {
    needRefresh: [hayNueva, setHayNueva],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });
  if (!hayNueva) return null;
  return (
    <div className="fixed inset-x-3 top-3 z-50 flex items-center gap-3 rounded-2xl bg-stone-900 p-3 text-sm text-white shadow-lg sm:mx-auto sm:max-w-lg dark:bg-stone-100 dark:text-stone-900">
      <Icono nombre="system_update" />
      <span className="flex-1">Hay una versión nueva de la app.</span>
      <Boton tamano="sm" variante="acento" onClick={() => void updateServiceWorker(true)}>
        Actualizar
      </Boton>
      <button
        type="button"
        onClick={() => setHayNueva(false)}
        aria-label="Más tarde"
        className="grid h-8 w-8 place-items-center"
      >
        <Icono nombre="close" />
      </button>
    </div>
  );
}
